
export const csiTenants = {
    csi: "csi",
    synergy: "synergy"
};

export const isCsiServiceProvider = (props, fromProps = true) => {
    if (!fromProps) {
        return Object.values(csiTenants).includes(props);
    }
    return Object.values(csiTenants).includes(props?.state?.theme?.values?.tenantFullName);
}